import React, { forwardRef, memo } from 'react';
import Countdown, { zeroPad } from 'react-countdown';

import styles from './RecordModal.module.scss';

const AbsoluteWrapper = ({ children }) => {
  return <div className={styles.face_timer}>{children}</div>;
};

const Completionist = () => (
  <AbsoluteWrapper>
    <p>00:00</p>
  </AbsoluteWrapper>
);

const renderer = ({ seconds, completed, minutes }) => {
  if (completed) {
    return <Completionist />;
  }
  return (
    <AbsoluteWrapper>
      <p>{`${zeroPad(minutes)}:${zeroPad(seconds)}`}</p>
    </AbsoluteWrapper>
  );
};

const Timer = forwardRef(({ timer, className }, ref) => {
  return (
    <Countdown
      date={Date.now() + timer * 1000}
      renderer={renderer}
      ref={ref}
      autoStart={false}
      className={className}
      itemScope
      itemType='https://schema.org/Property'
    />
  );
});
Timer.displayName = 'Timer';
export default memo(Timer);
